var exports = {
  "vK": "xcc377c0b--735ab7--banner",
  "eU": "xcc377c0b--735ab7--logo-and-banks",
  "wm": "xcc377c0b--735ab7--logo",
  "e4": "xcc377c0b--735ab7--banks",
  "n1": "xcc377c0b--735ab7--circle",
  "DH": "xcc377c0b--735ab7--bank-logo",
  "Ji": "xcc377c0b--735ab7--payment",
  "x6": "xcc377c0b--735ab7--button",
};

module.exports = exports;
